import React from 'react';
import Spinner from "react-bootstrap/Spinner";
import Header from './Header';
import Footer from './Footer';
import { Paginacion,getCurrentPage } from '../util/paginacion';



const ITEMS_PER_PAGE = 10;
export default class Projects extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			proyectos: [],
			loadingprojects:[],
			loadingprojectsState:true,
			loading: true,
			paginacion:'',
			currentPage:1
			
		};
		
	}
	render() {
		return (
			<div className="about-page" >
				<Header />

				<h1>Research and Innovation Projects</h1>
				<hr/>
				{this.state.loading ? '' :
				this.setState({loadingprojects:this.state.proyectos.slice((this.state.currentPage - 1) * ITEMS_PER_PAGE, this.state.currentPage * ITEMS_PER_PAGE),loadingprojectsState:false})
			 	}
				
				{this.state.loadingprojectsState ? <Spinner /> :this.state.loadingprojects.map((
					{title, acronym, description, startPeriod,endPeriod, organization, agenda, upmAccountable,
					participants,doi,fundsDescription,projectImg,fundsImg})=>{							
					return (

					<div className='project-card' on >

						<div className="description">
							
							<h1><b>{acronym}</b></h1>
							<table>
								<tr>
								{title}</tr>
								<tr>
								<br />
								<b>Start date: </b>{startPeriod}</tr>
								<tr>
								<b>End date: </b>{endPeriod.length>=0?endPeriod:''}</tr>
								<tr>
								<b>Organization:</b>{organization}</tr>
								<tr>
								<b>Program: </b>{agenda}</tr>
								<tr>
								<b>PI: </b>{upmAccountable}</tr>
								{participants.length<=0 ?'':
								<tr>
								<p>
								<b>Participants: </b>{participants.map((participante, currentValue)=>{return(<text>{participante} {currentValue< participants.length-1?',':''}</text>)})}
								</p>
								</tr>
									}
									<tr>
                                <b>DOI: </b><a href={'https://doi.org/' + doi} target="_blank">{doi}</a></tr>
							</table>
							
							<p>
								{fundsDescription.map((descrition, currentValue)=>{return(<p>{descrition}</p>)})}
							</p>

						</div>
						<div className="imagenes">
								<img src={projectImg} alt='Imagen del proyecto'/>
								<img src={fundsImg} alt='Imagen del proyecto'/>
						</div>
					</div>

					);
				})}
				{this.state.loadingprojectsState ?'':
				<Paginacion id="projects" itemPerPage ={ITEMS_PER_PAGE} length={this.state.proyectos.length}/>
				}
				{this.setState({currentPage:getCurrentPage("projects")})}
				<Footer />
			</div>
		)
	}
	componentDidMount(){
		window.scrollTo(0,0);
		fetch(process.env.PUBLIC_URL+"/assets/json/projects.json").then(res=>res.json()).then(proyectos=>this.setState({proyectos, loading: false}));
	}
	
}




   